import React from 'react';
import { ArrowRightIcon, XIcon, CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { transformations } from '../data/content';
export function TransformationSection() {
  return <section className="w-full bg-navy-900 py-0 lg:py-20" aria-labelledby="transformation-heading" data-id="element-200" data-mp="2wx48vkjr0uoy">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-201" data-mp="2rzc8s38ya29o">
        <Reveal className="max-w-3xl" data-id="element-202" data-mp="2s0nfobxozq50">
          <h2 id="transformation-heading" className="text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-203" data-mp="2nxh5wubdfgts">
            What changes when you implement this system
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-204" data-mp="2e87hbofqkgaf">
            Same market. Same hours in the day. A completely different business underneath you.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-3" data-id="element-205" data-mp="2498926yvumny">
          {transformations.map((item, i) => <Reveal key={item.label} delay={i * 0.06} className="h-full" data-id="element-206" data-mp="208fxh72jg5oi" data-mpi={i}>
              <article className="flex h-full flex-col rounded-2xl border border-white/10 bg-navy-800 p-7" data-id="element-207" data-mp="fakehl7x46u4">
                <h3 className="text-xs font-bold uppercase tracking-widest text-slate-400" data-id="element-208" data-mp="k22fuadus9fm">{item.label}</h3>

                <ul className="mt-5 space-y-3" data-id="element-209" data-mp="5dxuszrbvlto">
                  {item.before.map(line => <li key={line} className="flex gap-3 text-[15px] leading-relaxed text-slate-400" data-id="element-210" data-mp="abpwumlosobl">
                      <XIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-slate-500" data-id="element-211" data-mp="y1tri4gwddqg" />
                      <span className="line-through decoration-slate-500" data-id="element-212" data-mp="1316mjchx9r44">{line}</span>
                    </li>)}
                </ul>

                <div className="my-6 flex items-center gap-3" aria-hidden="true" data-id="element-213" data-mp="p03zoxj3scs5">
                  <span className="h-px flex-1 bg-white/10" data-id="element-214" data-mp="t1pforqxp76k" />
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-brand-gold text-navy-900" data-id="element-215" data-mp="39r4fl2lvas89">
                    <ArrowRightIcon className="h-4 w-4" data-id="element-216" data-mp="3dt7vc3fkkizc" />
                  </span>
                  <span className="h-px flex-1 bg-white/10" data-id="element-217" data-mp="1k9ppkq0x7gje" />
                </div>

                <ul className="mt-auto space-y-3" data-id="element-218" data-mp="1kbtpyxzm1xex">
                  {item.after.map(line => <li key={line} className="flex gap-3 text-[15px] font-semibold leading-relaxed text-white" data-id="element-219" data-mp="1fbo4y0nuj95t">
                      <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" data-id="element-220" data-mp="1ai384bxzol87" />
                      {line}
                    </li>)}
                </ul>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}